// extracted by mini-css-extract-plugin
export default {"grid":"DeliveryList_grid__1BRds"};